import { connect } from "react-redux";

const Method = (props) => {
   const { carts } = props;
   return (
      <div className="list-cart-container shipment-method ">
         <div className="title-container">
            <div className="svg-next-icon icon-title ic_payment_info">
            </div><span className="title">Phương thức thanh toán</span>
         </div>
         <div className="shipping-method-order-confirm">
            <div className="name">
               {carts.payment_method_name}
            </div>
         </div>
      </div>
   )
}

const mapStateToProps = (state) => {
   const { carts } = state;
   return {
      carts
   };
};

export default connect(mapStateToProps, {
})(Method)